import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Component } from '../../../concepts/objects';
import { KeyExpression } from '../../../platform/input/KeyExpression';
import { KeyInput } from '../../../platform/input/KeyInput';
import { Keys } from '../../../platform/input/Keys';
import { MouseInput } from '../../../platform/input/MouseInput';
import { resolve } from '../../Container';
import { EffectDirector, Effects } from '../visualization/EffectDirector';
import { ToolBehavior } from './ToolBehavior';

const isRepeatable = (x: any) => x instanceof Component && 'repeat' in Component.describe(x);
const expr = KeyExpression.parse('R');

export class RepeatToolBehavior extends ToolBehavior {

    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(EffectDirector) private effects!: EffectDirector;

    public getPreferredCursor(state: string) {
        if (state === 'repeating') {
            return 'crosshair';
        }
    }

    public onKeyDown(state: string, e: KeyInput) {
        if (state === 'idle' && expr.matches(e, true)) {
            return 'repeating';
        }
    }

    public onMouseUp(state: string, e: MouseInput): string | void {
        if (state === 'repeating') {
            const subject = e.targets.filter(isRepeatable)[0] ?? null;
            if (subject) this.dispatchRepeat(subject);
            return 'idle';
        }
    }

    public onKeyUp(state: string, e: KeyInput): string | void {
        if (state === 'repeating' && e.key === Keys.KEY_R) {
            const subject = e.targets.filter(isRepeatable)[0] ?? null;
            if (subject) this.dispatchRepeat(subject);
            return 'idle';
        }
    }

    private dispatchRepeat(subject: Component) {
        const { repeat } = Component.describe(subject);
        if (repeat) {
            this.dispatch(repeat, [subject.id]);
            this.effects.trigger(Effects.popIn, subject);
        }
    }
}
